






































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IUser, ICustomer, IProject } from '@/lib/interfaces';
import { getAllCustomers, getProject, updateProject, createProject } from '@/services/api.service';
import SupSelect from '@/components/select/SupSelect.vue';

@Component({
  directives: {
    focus,
  },
  components: {
    SupSelect,
  },
})
export default class ProjectEditor extends Vue {
  private project: IProject<false> = {
    title: '',
    key: '',
    managers: [],
    shared_code: 0,
    customer: '',
  };

  private get managersInputCount(): string[] {
    return this.project.managers.concat(['']);
  }

  private disabledOptionsWithout(myIndex: number): string[] {
    const res = this.project.managers.slice();
    res.splice(myIndex, 1);
    return res;
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    let project: IProject<false>;
    if (to.query.project_id) {
      project = await getProject(to.query.project_id as string, false);
    }
    next((vm: ProjectEditor) => {
      if (project) {
        vm.project = project;
      }
    });
  }

  private async editFinish() {
    const response = this.$route.query.project_id
      ? await updateProject(this.project)
      : await createProject(this.project);
    this.$router.push({
      name: 'projects',
    });
  }

  private changeCustomer(value: string) {
    this.project.customer = value;
  }

  private changeManager(index, value: string) {
    Vue.set(this.project.managers, index, value);
  }
}
